<div class="drawer-nav">
  <div class="drawer-nav__header">
    @if (site.settings()?.logo) {
      <img [src]="site.settings()!.logo" alt="Logo" class="drawer-nav__logo-img" />
    } @else {
      <span class="drawer-nav__logo-text">{{ site.settings()?.name ?? 'Aktiv By' }}</span>
    }
    <button matIconButton class="drawer-nav__close" (click)="close()" aria-label="Luk navigation">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <nav class="drawer-nav__nav" aria-label="Primær navigation">
    @for (item of site.navItems(); track item.id) {
      <a
        matButton
        class="drawer-nav__nav-link"
        [routerLink]="item.path"
        routerLinkActive="--active"
        [routerLinkActiveOptions]="{ exact: item.path === '/' }"
        (click)="close()"
      >
        <mat-icon>{{ item.icon }}</mat-icon>
        {{ item.title }}
      </a>
    }
  </nav>

  <!-- The header's "For foreninger" button, for when the header shows the hamburger. -->
  @if (site.associationPortalUrl(); as portalUrl) {
    <div class="drawer-nav__divider" aria-hidden="true"></div>

    <div class="drawer-nav__section">
      <a
        matButton
        class="drawer-nav__nav-link"
        [href]="portalUrl"
        target="_blank"
        rel="noopener noreferrer"
        (click)="close()"
      >
        <mat-icon>groups</mat-icon>For foreninger<span class="sr-only"> (åbner i ny fane)</span>
      </a>
    </div>
  }

  @if (site.showAccountModule()) {
    <div class="drawer-nav__divider" aria-hidden="true"></div>

    <div class="drawer-nav__auth">
      @if (auth.isAuthenticated()) {
        <a mat-button class="drawer-nav__nav-link" routerLink="/account/profile" (click)="close()">
          <mat-icon>person</mat-icon>Min side
        </a>
        <button mat-button class="drawer-nav__nav-link" (click)="auth.signOut()">
          <mat-icon>logout</mat-icon>Log ud
        </button>
      } @else {
        <button mat-button class="drawer-nav__nav-link" (click)="auth.signIn()">
          <mat-icon>login</mat-icon>Log ind
        </button>
        <a
          mat-flat-button
          class="drawer-nav__signup-btn"
          routerLink="/account/create"
          (click)="close()"
        >
          <mat-icon>person_add</mat-icon>Ny bruger
        </a>
      }
    </div>
  }
</div>
